var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylContractDialog"}},[(_vm.isMobileScreen)?_c('ylContractDialogMobile',{attrs:{"info":_vm.info},on:{"cancelModal":_vm.cancelModal}}):_c('ylContractDialogPC',{attrs:{"info":_vm.info},on:{"cancelModal":_vm.cancelModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }